import React, { useState } from 'react';
import { toast } from 'sonner';
import { adminApi, apiError } from '../../lib/adminApi';
import SocialPostCard from './SocialPostCard';
import { BarChart3, Loader2 } from 'lucide-react';

export default function SocialPosts({ posts, metaOk, reload }) {
  const [busy, setBusy] = useState(false);
  const published = posts.filter((p) => p.status === 'published');
  const sum = (net, k) => published.reduce((a, p) => a + (Number(p.stats?.[net]?.[k]) || 0), 0);

  const refresh = async () => {
    setBusy(true);
    try {
      const { data } = await adminApi.post('/admin/social/stats/refresh');
      toast.success(`Statistiche aggiornate (${data.updated} post)`);
      reload();
    } catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };

  return (
    <div className="space-y-3" data-testid="social-posts">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h3 className="text-white font-bold">Post creati ({posts.length}) · pubblicati {published.length}</h3>
        <div className="flex items-center gap-4 text-xs text-white/60">
          <span data-testid="stats-total-likes">Mi piace: <b className="text-white">{sum('instagram', 'likes') + sum('facebook', 'likes')}</b></span>
          <span data-testid="stats-total-comments">Commenti: <b className="text-white">{sum('instagram', 'comments') + sum('facebook', 'comments')}</b></span>
          <span data-testid="stats-total-views">Visualizzazioni: <b className="text-white">{sum('instagram', 'views') + sum('facebook', 'views')}</b></span>
          <button onClick={refresh} disabled={!metaOk || busy} data-testid="stats-refresh-btn" title={metaOk ? '' : 'Collega prima Meta'}
            className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg border border-white/15 text-white/80 hover:border-red-500 disabled:opacity-40 transition-colors">
            {busy ? <Loader2 size={14} className="animate-spin" /> : <BarChart3 size={14} />} Aggiorna statistiche
          </button>
        </div>
      </div>
      {posts.length === 0 && <p className="text-white/40 text-sm" data-testid="social-posts-empty">Nessun post ancora. Creane uno qui sopra.</p>}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {posts.map((p) => <SocialPostCard key={p.id} post={p} metaOk={metaOk} reload={reload} />)}
      </div>
    </div>
  );
}
